'use strict';

//Includes
import { BaseRemoteVectorLayerController } from 'plugin/base-portlet';

import { TerritoryRpLayer, TerritoryKreisLayer, TerritoryKommuneLayer } from './map/MapLayer';

const GlobalTerritorialRP = {
    ...TerritoryRpLayer,
    id: 'fliwas_territories_rp',
    uuid: 'fliwas_territories_rp',
    controller: BaseRemoteVectorLayerController
};
const GlobalTerritorialKreis = {
    ...TerritoryKreisLayer,
    id: 'fliwas_territories_kreis',
    uuid: 'fliwas_territories_kreis',
    controller: BaseRemoteVectorLayerController
};
const GlobalTerritorialKommune = {
    ...TerritoryKommuneLayer,
    id: 'fliwas_territories_kommune',
    uuid: 'fliwas_territories_kommune',
    controller: BaseRemoteVectorLayerController
};

export { GlobalTerritorialRP, GlobalTerritorialKreis, GlobalTerritorialKommune };




// WEBPACK FOOTER //
// ./js/territorial-portlet.js